import React from "react";
import { Table, Typography } from "antd";

export default function TabelaItensPedido(props) {
  const { Title } = Typography;

  const columns = [
    {
      title: "Item",
      dataIndex: "nome",
      key: "nome",
    },
    {
      title: "Quantidade",
      dataIndex: "quantidade",
      key: "quantidade",
    },
    {
      title: "Valor",
      dataIndex: "valor",
      key: "valor",
      render: (val) => props.formatarMoedaBr(val),
    },
  ];

  return (
    <>
      <Title level={5}>Itens adquiridos neste pedido:</Title>
      <Table
        dataSource={props.pedidoSelecionado.itens}
        columns={columns}
        rowKey={(record) => record.id || record.nome}
        pagination={false}
        bordered
      />
    </>
  );
}